import React, { useState } from "react";

const LoginToWordPressButton = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const handleLogin = async () => {
        setLoading(true);
        setError(null);
        window.location.href = "https://ecom.utusanrajasehari.com/auth/secret_login?code=423473847384789237"; // Redirect to WP Admin
    };
    return (
        <div>
            <button
                onClick={handleLogin}
                disabled={loading}
                style={{
                    padding: "10px 20px",
                    backgroundColor: "#8452a4",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: loading ? "not-allowed" : "pointer",
                }}
            >
                {loading ? "Logging in..." : "Login to Ecom Panel"}
            </button>

            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );
};

export default LoginToWordPressButton;
